export interface AccountState {
  user: {
    record_id: string | null
    my_iko_id: string | null
    display_name: string | null
    role: string | null
    language: string | null
  } | null
  configurations: any[]
  isLoading: boolean
  isAuthenticated: boolean
  error: string | null
}

export const initialAccountState: AccountState = {
  user: null,
  configurations: [],
  isLoading: true,
  isAuthenticated: false,
  error: null,
}